import getPlayfieldPosition from './playfieldPosition';
import './Hazard.css';

function Hazard({ hazard }) {
  return (
    <div
      className={`hazard hazard-${hazard.type}`}
      style={getPlayfieldPosition(hazard.x, hazard.y)}
      aria-hidden="true"
    >
      <span />
    </div>
  );
}

export default Hazard;
